;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type {
	TourLaunch,
	TourLaunchRouteResult,
} from "@/features/onboarding-tours/types/tour-definition";

export function resolvesTourLaunchRoute({
	launch,
	workspaceId,
	currentPathname = "",
	activeViewNames = [],
}: {
	launch: TourLaunch;
	workspaceId: string;
	currentPathname?: string;
	activeViewNames?: string[];
}): TourLaunchRouteResult {
	if ("startOnCurrentPage" in launch && launch.startOnCurrentPage) {
		return null;
	}

	if ("resolveStartRoute" in launch) {
		return launch.resolveStartRoute({
			activeViewNames,
			currentPathname,
			workspaceId,
		});
	}

	if ("startRoute" in launch) {
		return launch.startRoute({ workspaceId });
	}

	return null;
}

export function parseTourLaunchPath(path: string): {
	pathname: string;
	search: string;
} {
	const normalized = path.startsWith("/") ? `http://local${path}` : path;
	const parsed = new URL(normalized);
	return {
		pathname: parsed.pathname,
		search: parsed.search,
	};
}

export function isTourLaunchPathActive({
	currentPathname,
	currentSearch,
	targetRoute,
}: {
	currentPathname: string;
	currentSearch: string;
	targetRoute: string;
}): boolean {
	const target = parseTourLaunchPath(targetRoute);
	const normalizedCurrentSearch = currentSearch.startsWith("?")
		? currentSearch
		: currentSearch
			? `?${currentSearch}`
			: "";
	const normalizedCurrentPathname = currentPathname.replace(/\/$/, "") || "/";
	const normalizedTargetPathname = target.pathname.replace(/\/$/, "") || "/";

	if (normalizedCurrentPathname !== normalizedTargetPathname) {
		return false;
	}

	if (!target.search) {
		return true;
	}

	return normalizedCurrentSearch === target.search;
}
